<div class="flex items-center justify-center dialog-header">
  {{ type }} Center
  <div class="absolute right-2">
    <button (click)="handleCloseDialog()" class="outline-none p-5">
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>

<div class="dialog-content">
  <form [formGroup]="centerForm" (ngSubmit)="submitForm()" class="p-fluid grid grid-cols-2 gap-6">

    <!-- Center Name -->
    <div class="flex flex-col">
      <label for="center_name" class="mb-2 font-semibold">Center Name *</label>
      <input pInputText id="center_name" formControlName="center_name"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="centerForm.get('center_name')?.invalid && (centerForm.get('center_name')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Center name is required.
      </div>
    </div>

    <!-- Bot Client ID -->
    <div class="flex flex-col">
      <label for="bot_client_id" class="mb-2 font-semibold">Bot Client ID </label>
      <input pInputText id="bot_client_id" formControlName="bot_client_id"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
       <!-- <div *ngIf="centerForm.get('bot_client_id')?.invalid && (centerForm.get('bot_client_id')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Bot Client ID is required.
      </div>   -->
    </div>

    <!-- Status -->
    <div class="flex flex-col">
      <label for="status" class="mb-2 font-semibold">Status *</label>
      <p-dropdown id="status" [options]="statusOptions" formControlName="status" placeholder="Select a status"
        class="w-full" />
      <div *ngIf="centerForm.get('status')?.invalid && (centerForm.get('status')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Status is required.
      </div>
    </div>

    <!-- Submit Button -->
    <div class="col-span-2 flex justify-end mt-2">
      <p-button label="Submit" type="submit" [loading]="isLoading" icon="pi pi-check" class="w-full"
        [disabled]="centerForm.invalid || isLoading"></p-button>
    </div>

  </form>
</div>
